module.exports = __webpack_public_path__ + "img/calendar.3738e8fa.svg";